'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');

const Margin = (props) => jsxRuntime.jsx("div", { style: { margin: props.margin }, "data-zds": true, children: props.children });

exports.Margin = Margin;
//# sourceMappingURL=Margin.cjs.js.map
